

















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { ArrivalDeparture } from "../models/ArrivalDeparture";
import { ArrivalsDeparturesDay } from '../models/ArrivalsDeparturesDay';
import './ArrivalsDeparturesDaySelector.scss'
import Destination from "@/components/Passenger/models/Destination";
import moment from 'moment';
import { Passenger } from "@/components/Passenger/models/Passenger";
import Routes from '@/Routes';
import { DateHelper } from '@/util/DateHelper';

const todayYMD = new DateHelper().dateYMD(new Date());

@Component({
    components: {
      
    },
  })
export class ArrivalsDeparturesDaySelector extends Vue {

    @Prop({required: true})  
    destination: Destination;

    @Prop({default: () => []})  
    arrivalDepartureDays: ArrivalsDeparturesDay[];

    $dateHelper: DateHelper;
    
    todayYMD: string = todayYMD;

    get todayArrivalsDeparturesDay(): ArrivalsDeparturesDay {
      return this.arrivalDepartureDays.find(ad => ad.dateId === this.todayYMD);
    }

    get todayArrivalsDeparturesDayArrivalDepartures(): ArrivalDeparture[] {
      const today = this.todayArrivalsDeparturesDay;
      if (!today){
        return [];
      }
      return today.arrivalsDepartures;
    }

    get todayArrivalsDeparturesDayArrivalDeparturesCount(): number {
      return this.todayArrivalsDeparturesDayArrivalDepartures.length;
    }

    get nextDayAfterToday(): ArrivalsDeparturesDay {
      const todayIndex = this.arrivalDepartureDays.findIndex(ad => ad.dateId === this.todayYMD);
      return this.arrivalDepartureDays[todayIndex + 1];
    }

    get nextDayAfterTodayIsTomorrow(): boolean {
      if (!this.nextDayAfterToday){
        return false;
      }
      return this.nextDayAfterToday.isTomorrow;
    }

    get nextDayAfterTodayArrivalDepartures(): ArrivalDeparture[] {
      if (!this.nextDayAfterToday){
        return [];
      }
      return this.nextDayAfterToday.arrivalsDepartures;
    }

    get nextDayAfterTodayArrivalDeparturesCount(): number {
      return this.nextDayAfterTodayArrivalDepartures.length;
    }

    get nextDayAfterTodayWeekdayName(): string {
      if (this.nextDayAfterTodayIsTomorrow){
        return this.$i18n.translate("generic.tomorrow.lowercase", "tomorrow");
      }
      return this.nextDayAfterToday.weekDayName;
    }

    get showWeekends(): boolean {
      return this.$store.state.user.showWeekends;
    }

    get routeDateId(): string | undefined {
      return this.$store.state.route.params.dateId;
    }

    get routeDestinationId(): number {
      return parseInt(this.$store.state.route.params.destinationId, 10);
    }

    get routeName(): string {
      return this.$route.name;
    }

    redirectToFirstAvailableDay(timeout: number){
      setTimeout(f => {
        if (this.arrivalDepartureDays.length > 0){
          this.$router.replace({
            name: 'ArrivalsDeparturesDestinationDay', 
            params: { 
              dateId: this.arrivalDepartureDays[0].dateId.toString(),
            }
          });
        }
      }, timeout);
    }

    @Watch('routeName', { immediate: true }) onRouteNameChanged(val, oldVal){
      if (val === Routes.arrivalsDeparturesRoute.name && !this.routeDateId){
        this.redirectToFirstAvailableDay(500);  
      }
    }

    @Watch('routeDestinationId', { immediate: true }) onRouteDestinationIdChanged(val, oldVal) {
      if (this.routeDestinationId !== val) {
        this.redirectToFirstAvailableDay(500);
      }
    }
}

export default ArrivalsDeparturesDaySelector;
